import React, { useState, useEffect } from "react";
import MaterialTable from 'material-table';
import axios from 'axios';
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import { getTrans as t } from "../../../Localization/translations";
import Helper from "../../../Helper";
import { useNavigate } from "react-router-dom";
import PartyRoleList from "./PartyRoleList";

const PartyRoleViewList = ({ id, contracttype }) => {
    const [itemsPartyRole, setItemsPartyRole] = useState([]);
    const [partyrolehideshow, setPartyRoleHideShow] = useState(false);
    const [partyroleid, setPartyRoleId] = useState(false);
    let navigate = useNavigate();

    const handelDefault = () => {
        let url = `${API}party-roles/?contract_id=${id}`;
        axios.get(url, { headers: authHeader() })
            .then(response => {
                if (response.data.success === 1) {
                    setItemsPartyRole(response.data.response);
                }
            })
            .catch(error => {
                console.error("Error fetching party roles:", error);
            });
    };

    useEffect(() => {
        handelDefault();
    }, []);

    const handleView = (party_role_id) => {
        setPartyRoleId(party_role_id);
        setPartyRoleHideShow(true);
    };

    return (
        <>
            {
                partyrolehideshow === false ?
                    <div className="panel-content" style={{ position: "relative", minHeight: "138vh" }}>
                        <div className="row py-2 mt-3" id="partyroles" style={{ marginBottom: "50px" }}>
                            <div className=""
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    overflowX: "auto",
                                }}>
                                <div className="mb-0">
                                    <div className="header pb-0 pt-2">
                                        <div className="d-lg-flex">
                                            <div>
                                                <h5 className="mb-3">{t('Party Role')}</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="pb-0">
                                            <MaterialTable
                                                style={{
                                                    backgroundColor: "var(--bs-table-bg)",
                                                    borderBottomWidth: "1px",
                                                    boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                                }}
                                                onRowClick={(event, rowData) => {
                                                    handleView(rowData.id);
                                                }}
                                                columns={[
                                                    {
                                                        title: `${t("Party")}`,
                                                        field: "party",
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left"
                                                        },
                                                        cellStyle: {
                                                            textAlign: "left",
                                                            fontSize: 12
                                                        },
                                                        render: rowData => (
                                                            <>
                                                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Party")}</div>
                                                                <div className="hyperlink">{rowData.party}</div>
                                                            </>
                                                        ),
                                                    },
                                                    {
                                                        title: `${t("Role")}`,
                                                        field: "role",
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left"
                                                        },
                                                        cellStyle: {
                                                            textAlign: "left",
                                                            fontSize: 12
                                                        },
                                                        render: rowData => (
                                                            <>
                                                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Role")}</div>
                                                                <div>{rowData.role ? rowData.role : "None"}</div>
                                                            </>
                                                        ),
                                                    },
                                                    {
                                                        title: `${t("Created At")}`,
                                                        field: "created_at",
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left"
                                                        },
                                                        cellStyle: {
                                                            textAlign: "left",
                                                            fontSize: 12
                                                        },
                                                        render: rowData => (
                                                            <>
                                                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Created At")}</div>
                                                                <div>{rowData.created_at ? Helper.DateNormal(rowData.created_at) : "None"}</div>
                                                            </>
                                                        ),
                                                    },
                                                    {
                                                        title: `${t("Updated At")}`,
                                                        field: "updated_at",
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left"
                                                        },
                                                        cellStyle: {
                                                            textAlign: "left",
                                                            fontSize: 12
                                                        },
                                                        render: rowData => (
                                                            <>
                                                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Updated At")}</div>
                                                                <div>{rowData.updated_at ? Helper.DateNormal(rowData.updated_at) : "None"}</div>
                                                            </>
                                                        ),
                                                    },
                                                ]}
                                                data={itemsPartyRole}
                                                options={{
                                                    headerStyle: {
                                                        backgroundColor: "white",
                                                        color: "#245C7F",
                                                        fontSize: 12,
                                                    },
                                                    rowStyle: (rowData, index) => {
                                                        if (index % 2) {
                                                            return { backgroundColor: "#fff" };
                                                        }
                                                    },
                                                    sorting: true,
                                                    search: false,
                                                    toolbar: false,
                                                    paging: true,
                                                    pageSize: 5,
                                                    emptyRowsWhenPaging: false,
                                                    pageSizeOptions: [5, 15, 20, 50],
                                                    paginationType: "stepped",
                                                    showFirstLastPageButtons: false,
                                                    actionsColumnIndex: -1,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <PartyRoleList party_role_id={partyroleid} id={id} contracttype={contracttype} />
            }
        </>
    );
}

export default PartyRoleViewList;